module.exports = __webpack_public_path__ + "2164a88d56c91916d7252d9b66e314d0.svg";